export default __webpack_public_path__ + "static/media/SF Logo.35db46f4.png";